import api, { isMockEnabled } from './axiosConfig';
import { BLOG_ENDPOINT, BLOG_CATEGORIES_ENDPOINT } from './apiEndpoints';
import blogs from '../data/blogs';
import { logError } from './errorLogService';

const mockBlogData = blogs;

const categories = [
    { id: 1, description: 'Technical Articles', blogCount: 1 },
    { id: 2, description: 'Sustainability', blogCount: 1 },
    { id: 3, description: 'Company News', blogCount: 1 },
    { id: 4, description: 'Product Innovations', blogCount: 1 },
    { id: 5, description: 'Industry Insights', blogCount: 1 },
    { id: 6, description: 'Events and Announcements', blogCount: 1 },
    { id: 7, description: 'Customer Success Stories', blogCount: 1 },
    { id: 8, description: 'Community Engagement', blogCount: 1 },
    { id: 9, description: 'Regulatory Updates', blogCount: 1 },
    { id: 10, description: 'Employee Spotlights', blogCount: 1 },
]

export const fetchBlog = async (tag = null, category = null) => {
    // if (isMockEnabled) {
    //     return mockBlogData; // Usa datos mock si está activado
    // }
    try {
        // console.log('service', tag, category)
        const params = new URLSearchParams();
        if (tag) params.append("tag", tag);
        if (category) params.append("category", category);

        // Enviar request con parámetros
        const response = await api.get(`${BLOG_ENDPOINT()}?${params.toString()}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching blog data", error);

        await logError('blog_data_fetch', error, {
            endpoint: `${BLOG_ENDPOINT()}?tag=${tag}&category=${category}`,
            tag,
            category,
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        throw new Error('Error fetching blog data');

        // return mockBlogData; // Devuelve datos mock en caso de error
    }
};


export const fetchBlogCategories = async (retryCount = 2) => {
    // if (isMockEnabled) {
    //     return mockBlogData; // Usa datos mock si está activado
    // }

    try {
        const response = await api.get(BLOG_CATEGORIES_ENDPOINT(), {
            timeout: 30000, // 30 seconds timeout
        });
        return response.data;
    } catch (error) {
        const isTimeout = error.code === 'ECONNABORTED' || error.message?.includes('timeout');
        const isNetworkError = !error.response && error.request;
        
        // Retry logic for timeouts and network errors
        if ((isTimeout || isNetworkError) && retryCount > 0) {
            console.warn(`Blog categories fetch ${isTimeout ? 'timeout' : 'network error'}, retrying... (${retryCount} attempts left)`);
            await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second before retry
            return fetchBlogCategories(retryCount - 1);
        }

        console.error("Error fetching hero data", error);

        await logError('blog_categories_fetch', error, {
            endpoint: BLOG_CATEGORIES_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        return categories;
    }
};